import moment from "moment";

export const createdAgo = (dateObject) => {
  if (!dateObject) {
    return "Invalid date";
  }

  const createdDate = moment({
    year: dateObject.year,
    month: dateObject.monthValue - 1, // Month is 0-indexed in Moment.js
    day: dateObject.dayOfMonth,
    hour: dateObject.hour,
    minute: dateObject.minute,
    second: dateObject.second,
    millisecond: Math.floor(dateObject.nano / 1000000),
  });

  return createdDate.fromNow();
};

export const commentTimeFormat = (dateObject) => {
  if (!dateObject) {
    return "Invalid date";
  }

  const createdDate = moment({
    year: dateObject.year,
    month: dateObject.monthValue - 1, // Month is 0-indexed in Moment.js
    day: dateObject.dayOfMonth,
    hour: dateObject.hour,
    minute: dateObject.minute,
    second: dateObject.second,
    millisecond: Math.floor(dateObject.nano / 1000000),
  });

  const today = moment();
  const isSameDay = today.isSame(createdDate, 'day');

  if (isSameDay) {
    return createdDate.format('h:mm A'); // AM/PM format for the same day
  } else {
    return createdDate.fromNow(); // Relative time for other dates
  }
};
